import DocModelo from '@/models/DocModelo'
import { LocalStorageFacade } from 'paliari-js-utils'

export default {
  data() {
    return { resource: null }
  },
  methods: {
    navigate(routeName) {
      LocalStorageFacade.setItem('docModelo', this.resource)
      this.$router.push({
        name: routeName,
        params: this.$route.params,
      })
    },
  },
  created() {
    const params = LocalStorageFacade.getItem('docModelo') || {}
    this.resource = new DocModelo(params)
  },
}
